<template>
	<div class="prebuild-banner">
		<div class="container">
			<div class="prebuild-banner__content">
				<div class="prebuild-banner__text">
					<h2 class="prebuild-banner__series-name">
						{{ title }}
					</h2>
					<h4 class="prebuild-banner__subheading">
						{{ description }}
					</h4>
				</div>
				<div class="prebuild-banner__button-container">
					<h4 class="prebuild-banner__subheading">
						Starting at $699
					</h4>
					<a
						class="prebuild-banner__button btn"
						v-scroll-to="{
							el: '#product-card',
							offset: -100
						}"
					>
						Buy
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PrebuildStickyBanner",
	props: {
		title: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.prebuild-banner {
	background-color: #fff;
	width: 100%;
	padding: 20px 0;
	box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
	min-height: 96px;
	display: flex;
	align-items: center;

	@media (max-width: 768px) {
		.container {
			width: 100%;
		}
	}

	&__content {
		display: flex;
		justify-content: space-between;
	}

	&__text {
		@media (max-width: 767px) {
			display: flex;
			align-items: center;
		}
	}

	&__series-name {
		color: #444259;
		font-size: 32px;
		font-weight: bold;
		letter-spacing: 0;
		margin: 0;

		@media (max-width: 767px) {
			font-size: 24px;
		}
	}

	&__subheading {
		color: #5f707f;
		font-size: 16px;
		letter-spacing: 0;
		margin: 0;

		@media (max-width: 767px) {
			display: none;
		}
	}

	&__button-container {
		display: flex;
		align-items: center;
	}

	&__button {
		background: $oldpurple;
		color: #fff;
		margin-left: 15px;
		padding: 12px 50px;
		border-radius: 2px;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0;
		text-transform: none;

		@media (max-width: 767px) {
			padding: 11px 17px;
		}

		@media (hover: hover) {
			&:hover {
				background: transparent;
				color: $oldpurple;
				border: solid 2px $oldpurple;
			}
		}
	}
}
</style>
